import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeVacancy } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface VacanciesOverviewProps {
  entities: Immutable.List<ImmutableEntity<NodeVacancy>>;
}

const VacanciesOverview: React.FC<VacanciesOverviewProps> = ({ entities }) => {
  const { t } = useTranslation();

  if (entities.size === 0) {
    return (
      <div className="VacanciesOverview__empty">
        <h3>{t('content_types.vacancy.empty_state_title')}</h3>
      </div>
    );
  }

  return (
    <div className="VacanciesOverview row">
      {
        entities.map((entity) => {
          const id = entity.getIn(['nid', 0, 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const key = `${uuid}:${langcode}`;

          return (
            <Node
              id={id}
              key={key}
              entity={entity}
              viewMode="teaser"
            />
          );
        })
      }
    </div>
  );
};

export default VacanciesOverview;
